<template>
  <div v-if="!roomsLoading"
       :key="idRoomLast"
       :class="$setClasses">
    <div :class="$vClass('top')">
      <div :class="$vClass('label')">
        <nxt-core-input-label :text="titleInventory"/>
      </div>
      <div v-if="isMobile"
           :class="$vClass('room-selector')">
        <el-select v-model="activeRoom"
                   :class="$vPrefix('grey-input')"
                   :teleported="false"
                   popper-class="custom nxt-app">
          <el-option v-for="(room, index) in rooms"
                     :key="room.id"
                     :label="`${room.name} (${getFurnituresCount(room)})`"
                     :value="index">
          </el-option>
        </el-select>
        <img
          :class="[$vClass('room-selector__burger_menu'), !rooms[activeRoom] ? $vPrefix('--hidden') : '']"
          :src="burgerMenuPath"
          alt="display search bar"
          @click="displaySearchBar = !displaySearchBar"
        />
        <font-awesome-icon :class="[$vClass('header__icon'),
                           !rooms[activeRoom] ? $vPrefix('--hidden') : '']"
                           :icon="['fal', 'trash-alt']"
                           @click="deleteRoom"/>

      </div>
      <div v-else
           :class="[$vClass('header'),
      {'is-flex': isScrollable}]">
        <nxt-core-inline-selector ref="room-list"
                                  :activeItem="activeRoom"
                                  :items="rooms"
                                  has-custom-scroll
                                  @isScrollable="handleIsScrollable"
                                  @update:item="onRoomSelected"
                                  @scroll:element="scroll">
          <template v-slot:default="slotPros">
            <div v-if="!(editRoomName && slotPros.isSelected)"
                 :class="[$vClass('header__room-item'),
            {[$vClass('header__room-item--active')]: slotPros.isSelected}]">
              {{ slotPros.item.name }} ({{ getFurnituresCount(slotPros.item) }})
            </div>
            <div v-else
                 :class="[$vClass('header__room-item'),
            {[$vClass('header__room-item--edit')]: slotPros.isSelected}]">
              <el-input v-model="editingName"
                        :class="[$vPrefix('grey-input'),
                        editingName.length && $vPrefix('u-color-primary')].join(' ')"
                        :placeholder="slotPros.item.name"
                        suffix-icon="Check"
                        @blur="onBlur"
                        @change="()=>{onEditChange(slotPros)}"
                        @clear="onEditCleared"/>
            </div>
          </template>
          <template v-if="displayAddRoom"
                    v-slot:addRoom>
            <div :class="[$vClass('header__room-item'),
             $vClass('header__add-room'), {[$vClass('header__room-item--edit')]: true}]">
              <el-input ref="inputAddRoom"
                        v-model="newRoom"
                        :class="[$vPrefix('grey-input'),
                        newRoom.length && $vPrefix('u-color-primary')].join(' ')"
                        :placeholder="$t('rooms.newRoom.placeholder')"
                        suffix-icon="Check"
                        @blur="displayAddRoom = false"
                        @change="addRoom"
              >
              </el-input>
            </div>
          </template>
        </nxt-core-inline-selector>
        <iconBox :edit-show="!!currentRoom"
                 :trash-show="!!currentRoom"
                 @addRoom="handlerDisplayAddRoom"
                 @deleteRoom="deleteRoom"
                 @editRoom="onEditRoomName"/>
      </div>
    </div>
    <transition :name="$vPrefix('fade')"
                mode="out-in">
      <nxt-core-furniture-selector v-if="currentRoom"
                                   :key="currentRoom.id"
                                   :auto-disassembly="autoDisassembly"
                                   :display-search-bar="displaySearch"
                                   :height-list="heightList"
                                   :init="init"
                                   :room-furniture="roomFurniture"
                                   has-custom-scroll
                                   sizeLoader="--size-small"
                                   topCustomModal="0px"
                                   @update:furniture="updateRoom">
        <template v-slot:footer>
          <div :class="$vClass('footer__text')">
            <p>
              Meubles : {{ furnituresNb }}</p>
            <p>
              Volume : {{ $filters.format.convertToInteger(furnituresVolume) }}</p>
          </div>
        </template>
      </nxt-core-furniture-selector>
    </transition>
    <nxt-core-disassemble-modal v-model:visible="displayModal"
                                top="0px"
                                @update:furniture="setFirstFurnitureDisassembly"
                                @update:disassembly="setAutoDisassembly"
    ></nxt-core-disassemble-modal>
    <nxt-core-modal v-model:visible="displayWarningDeletion"
                    :class="$vClass('room-delete')"
                    top="0px"
                    width="400px"
    >
      <template v-slot:header>
        <span :class="$vPrefix('warning-deletion__title')"> {{ currentRoomName }} </span>
      </template>
      <span :class="$vPrefix('warning-deletion__content')">
        {{ $t('inventory.warningDeletion', { number: getFurnituresCount(currentRoom) }) }}
      </span>
      <br/>
      <span v-if="isMobile"
            :class="$vPrefix('warning-deletion__footer')">
        <nxt-core-btn :class="[$vPrefix('warning-deletion__footer__left'),
        'nxt-button nxt-button__light-grey']"
                      :title="$t('base.no')"
                      @click="displayWarningDeletion = false"></nxt-core-btn>
        <nxt-core-btn :title="$t('base.delete')"
                      class="nxt-button nxt-button__danger"
                      @click="deleteRoomWithFurniture"></nxt-core-btn>
      </span>
      <template v-if="!isMobile"
                v-slot:footer>
        <span :class="$vPrefix('warning-deletion__footer')">
          <nxt-core-btn :class="[$vPrefix('warning-deletion__footer__left'),
               'nxt-button__light-grey nxt-button']"
                        :title="$t('base.no')"
                        @click="displayWarningDeletion = false"></nxt-core-btn>
          <nxt-core-btn :class="[$vPrefix('warning-deletion__footer__right'),
               'nxt-button nxt-button__danger']"
                        :title="$t('base.delete')"
                        @click="deleteRoomWithFurniture"></nxt-core-btn>
        </span>
      </template>
    </nxt-core-modal>
  </div>
  <nxt-core-loader v-else
                   sizeLoader="--size-small"></nxt-core-loader>
</template>

<script>
import { mapState } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';
import FurnitureInventory
  from '@nextories/vue-core-components/src/components/organisms/furnitures/NxtCoreFurnitureInventory.vue';
import Inventory
  from '@nextories/vue-core-components/src/components/organisms/NxtCoreInventory.vue';

export default {
  extends: FurnitureInventory,
  name: 'Inventory',
  nameClassStyle: 'inventory',
  props: {
    ...Inventory.props,
    indexField: Number,
  },
  data() {
    return {
      ...Inventory.data(),
    };
  },
  computed: {
    ...Inventory.computed,
    ...mapState(usePartnerStore, {
      step: 'currentStep',
    }),
  },
  methods: {
    ...Inventory.methods,
    scroll(el) {
      this.$helpers.scroll.scrollItem(el, this.$refs['room-list'], 30);
    },
  },
  async created() {
    this.initRoomSelected(0);
    if (this.standardFurniture.length === 0) {
      this.getFurnituresList()
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (!this.isModal) {
            this.step.fields[this.indexField].value = Math.ceil(this.furnituresVolume);
          }
          this.init = true;
        });
    } else {
      this.init = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@use '@nextories/vue-core-components/src/assets/scss/components/organisms/NxtCoreInventory';

.#{$prefixName}inventory {
  display: block;
}
</style>
